import { useQuery } from '@tanstack/react-query';
import {
  checkPurchaseEligibility,
  EligibilityResult,
} from '@/services/purchase-eligibility';

export default function usePurchaseEligibility({
  userId,
  email,
  phone,
  countryCode,
  classPackId,
  subscriptionId,
  switchFromSubscriptionCodeId,
}: {
  userId?: string;
  email?: string;
  phone?: string;
  countryCode?: string;
  classPackId?: string;
  subscriptionId?: string;
  switchFromSubscriptionCodeId?: string;
} = {}) {
  const enabled = (!!userId || !!email) && (!!classPackId || !!subscriptionId);

  const { data, isLoading, error } = useQuery({
    queryKey: [
      'purchaseEligibility',
      userId,
      email,
      phone,
      countryCode,
      classPackId,
      subscriptionId,
      switchFromSubscriptionCodeId,
    ],
    queryFn: () =>
      checkPurchaseEligibility({
        user_id: userId,
        email,
        phone,
        country_code: countryCode,
        class_pack_id: classPackId,
        subscription_id: subscriptionId,
        switch_from_subscription_code_id: switchFromSubscriptionCodeId,
      }),
    enabled,
  });

  const classPackEligibility: EligibilityResult | null =
    data?.class_pack ?? null;
  const subscriptionEligibility: EligibilityResult | null =
    data?.subscription ?? null;

  return {
    classPackEligibility,
    subscriptionEligibility,
    isLoading: enabled && isLoading,
    error,
  };
}
